import { FunctionComponent } from "react";

export interface CheckBoxProps {
  id: string;
  checked: boolean;
  label: string;
  error?: boolean;
  errorText?: String;
  setChecked: Function;
  showLabel?: boolean;
  type: string;
}

const CheckBox: FunctionComponent<CheckBoxProps> = ({
  id,
  checked,
  setChecked,
  label,
  error,
  errorText,
}) => {
  return (
    <div>
      <label className="inline-flex items-start text-left cursor-pointer ">
        <input
          type="checkbox"
          className={`h-6 w-6 rounded-sm ${
            error ? "border-red-500" : "border-gray-300"
          } focus:border-primary focus:ring-0 focus:ring-indigo-200 focus:ring-opacity-50 text-primary`}
          checked={checked}
          onChange={(e) => setChecked(e.target.checked, id)}
        />
        <span className="ml-4 ">{label}</span>
      </label>
      {error ? (
        <p className="ml-10 mt-2 text-xs text-red-500">{errorText}</p>
      ) : null}
    </div>
  );
};

export default CheckBox;
